export function copyString(text, useSelectionRange = false) {
    const activeElement = document.activeElement;
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'absolute';
    textArea.style.left = '-9999px';
    textArea.style.top = '-9999px';
    document.body.appendChild(textArea);
    try {
        if (useSelectionRange) {
            textArea.contentEditable = 'true';
            textArea.readOnly = false;
            const range = document.createRange();
            const selection = self.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
            textArea.setSelectionRange(0, 999999);
        }
        else {
            textArea.focus();
            textArea.select();
        }
        if (!document.execCommand('copy')) {
            throw new Error('Unable to copy into clipboard');
        }
    }
    finally {
        document.body.removeChild(textArea);
        if (activeElement !== null) {
            activeElement.focus();
        }
    }
}
